// Authentication utilities

export interface AuthUser {
  email: string;
  role: 'Super Admin' | 'Editor' | 'Viewer';
}

const AUTH_KEY = 'arithmify_auth';
const AUTH_EXPIRY_KEY = 'arithmify_auth_expiry';

export const demoAccounts = [
  {
    role: 'Super Admin' as const,
    email: 'admin@arithmify.io',
    password: 'Arithmify@2026',
  },
  {
    role: 'Editor' as const,
    email: 'editor@arithmify.io',
    password: 'Editor@2026',
  },
  {
    role: 'Viewer' as const,
    email: 'viewer@arithmify.io',
    password: 'Viewer@2026',
  },
];

export function setAuthUser(user: AuthUser, rememberMe: boolean = false) {
  if (typeof window !== 'undefined') {
    localStorage.setItem(AUTH_KEY, JSON.stringify(user));
    
    if (rememberMe) {
      // Store for 30 days
      const expiryDate = new Date();
      expiryDate.setDate(expiryDate.getDate() + 30);
      localStorage.setItem(AUTH_EXPIRY_KEY, expiryDate.toISOString());
    } else {
      // Session-based: expires when browser closes
      localStorage.removeItem(AUTH_EXPIRY_KEY);
    }
  }
}

export function getAuthUser(): AuthUser | null {
  if (typeof window !== 'undefined') {
    const user = localStorage.getItem(AUTH_KEY);
    const expiry = localStorage.getItem(AUTH_EXPIRY_KEY);
    
    if (!user) return null;
    
    // Check if auth has expired
    if (expiry) {
      const expiryDate = new Date(expiry);
      if (new Date() > expiryDate) {
        clearAuthUser();
        return null;
      }
    }
    
    try {
      return JSON.parse(user) as AuthUser;
    } catch {
      clearAuthUser();
      return null;
    }
  }
  return null;
}

export function clearAuthUser() {
  if (typeof window !== 'undefined') {
    localStorage.removeItem(AUTH_KEY);
    localStorage.removeItem(AUTH_EXPIRY_KEY);
  }
}

export function isAuthenticated(): boolean {
  return getAuthUser() !== null;
}

export function logout() {
  clearAuthUser();
  if (typeof window !== 'undefined') {
    // Use a small delay to ensure state is cleared before redirect
    setTimeout(() => {
      window.location.href = '/sign-up-login-screen';
    }, 100);
  }
}
